import React from 'react';
import PropTypes from 'prop-types';

function StarRating({ value, onChange, size = 'md', interactive = false }) {
  const stars = [1, 2, 3, 4, 5];
  const rounded = Math.round(Number(value) || 0);

  return (
    <div
      className={`star-rating star-rating-${size}${
        interactive ? ' star-rating-interactive' : ''
      }`}
      role={interactive ? 'radiogroup' : 'img'}
      aria-label={`${rounded} out of 5 stars`}
    >
      {stars.map((star) => {
        const filled = star <= rounded;
        if (!interactive) {
          return (
            <span
              key={star}
              className={`star ${filled ? 'star-filled' : 'star-empty'}`}
              aria-hidden="true"
            >
              ★
            </span>
          );
        }
        return (
          <button
            key={star}
            type="button"
            className={`star-btn ${filled ? 'star-filled' : 'star-empty'}`}
            aria-label={`${star} star${star === 1 ? '' : 's'}`}
            aria-checked={star === rounded}
            role="radio"
            onClick={() => onChange && onChange(star)}
          >
            ★
          </button>
        );
      })}
    </div>
  );
}

StarRating.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  interactive: PropTypes.bool,
};

export default StarRating;
